module.exports = __webpack_public_path__ + "img/curiosis.e9d6e3d3.png";